import Icon from '@mdi/react'
import styled, { css, keyframes } from 'styled-components'

import CommonLinkButton from 'components/Button/CommonLinkButton'
import theme from 'theme_'
import { Font12 } from 'components/Typography'

const licensesBaseFlex = css`
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  align-items: center;
`

export const NotesContainer = styled.div`
  ${licensesBaseFlex};
  width: 100%;
  justify-content: space-between;
`

export const NotesInfoWrapper = styled.div`
  height: 40px;
  width: 100%;
  ${licensesBaseFlex};
  justify-content: center;
`

export const NotesEditorContainer = styled.div`
  ${licensesBaseFlex};
  position: relative;
  width: 100%;
`

export const NotesStyledTextarea = styled.textarea`
  ${Font12};
  line-height: 17px;
  background: ${theme.colors.white};
  padding: 4px 8px;
  width: 100%;
  height: 40px;
  border: none;
  -webkit-appearance: none;
  box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  -webkit-box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  border-radius: 8px;
  outline: none;
  resize: none;
`

export const NotesTooltip = styled.span`
  display: none;
  z-index: 3;
  flex-direction: row;
  align-items: center;
  min-height: 32px;
  background: ${theme.colors.white};
  padding: 4px 8px;
  position: absolute;
  top: 20px;
  left: 16px;
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.5s ease;
  word-break: break-all;
`
export const NotesText = styled.div`
  ${Font12};
  line-height: 17px;
  padding: 4px 8px;
  width: 100%;
  outline: none;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: default;
  word-break: break-all;
  height: 40px;
  border: none;
  box-shadow: ${`inset 0 0 0 1px ${theme.colors.lightGrey}`};
  border-radius: 8px;

  :hover > span {
    display: flex;
    transition: opacity 0.5s ease;
    opacity: 1;
  }
`

const notesButtonsAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`

export const NotesButtonsContainer = styled.div<{ editMode: boolean }>`
  display: ${(p) => (p && p.editMode ? 'flex' : 'none')};
  position: absolute;
  z-index: 3;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 80px;
  height: 32px;
  right: 0;
  bottom: -36px;
  padding: 4px;
  background: ${theme.colors.white};
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  border-radius: 8px;
  animation-name: ${notesButtonsAnimation};
  animation-duration: 0.2s;

  @media ${theme.devices.tablet} {
    right: 101%;
    bottom: 4px;
  }
  @media ${theme.devices.mediumDesktop} {
    right: 0;
    bottom: -36px;
  }
`

export const NotesSubmitButton = styled(CommonLinkButton)`
  ${licensesBaseFlex};
  justify-content: center;
`

export const NotesRejectButton = styled(CommonLinkButton)`
  ${licensesBaseFlex};
  justify-content: center;
`

export const NotesEditModeButton = styled.div`
  margin-left: 16px;
  ${licensesBaseFlex};
  justify-content: center;
`

export const NotesStyledIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`
